import { useQuery } from '@tanstack/react-query';
import type { ClaimDetail } from '@/lib/api-admin/types';
import { apiClient } from '@/lib/apiClient';

export const claimQueryKey = (claimId: string) => ['admin', 'claim', claimId] as const;

export const useClaimQuery = (claimId: string | undefined) =>
  useQuery<ClaimDetail>({
    queryKey: claimQueryKey(claimId ?? ''),
    enabled: Boolean(claimId),
    queryFn: async () => {
      const [data] = await apiClient.request('get', '/api/admin/v1/claims/{claimId}', {
        params: { path: { claimId: claimId as string } },
      });
      return data as ClaimDetail;
    },
  });
